// extracted by mini-css-extract-plugin
module.exports = {"el":"HeaderLogo-module--el--UbR5M"};